import { Flex } from '@applyboard/crystal-ui';

import { GradeConversionDetailsHeading } from '../components/GradeConversionDetailsHeading';
import { GradeConversionInformation } from '../components/GradeConversionInformation';
import { GradeConversionLayoutProps } from './types';

export function TabletLayout(props: GradeConversionLayoutProps) {
  const { conversionTable, gradeSchema, gradePointMappings, educationLevels, countries } = props;

  return (
    <Flex p={6} gap={6} direction="column">
      <GradeConversionDetailsHeading />
      <GradeConversionInformation
        conversionTable={conversionTable}
        gradeSchema={gradeSchema}
        gradePointMappings={gradePointMappings}
        educationLevels={educationLevels}
        countries={countries}
      />
    </Flex>
  );
}
